import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Router } from "react-router";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import {
  ADD_TASK,
  DELETE_TASK,
  LOAD_COURSES,
  LOAD_LINKS,
  LOAD_TIMESLOTS,
  SET_CALENDAR_EVENTS,
  SET_COURSES,
  SET_TASKS,
  UNDO_DELETE_TASK,
  UNDO_DELETE_SCHEDULED,
  DELETE_SCHEDULED,
  LOAD_NEW_SCHEDULED,
} from "./Constants/reducerEvents";
import { appLoad } from "./Endpoints";
import Header from "./Navigation/Header";
import Calendar from "./Pages/Schedule";
import Home from "./Pages/Home";
import Preferences from "./Pages/Preferences";
import TaskCalendar from "./Pages/TaskCalendar";
import SocketClient from "./Socket";
import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { ListItem } from "@mui/material";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import TodayIcon from "@mui/icons-material/Today";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import moment from "moment";
import TaskPreview from "./Components/TaskPreview";
import DayCalendar from "./Components/DayCalendar";
import { Delete, UndoOutlined } from "@mui/icons-material";
import TaskPopup from "./Components/Popups/TaskPopup";
import Scheduler from "./Pages/Scheduler";
import ScheduledTask from "./Components/DragAndDrop/ScheduledTask";
import TaskContainer from "./Components/DragAndDrop/TaskContainer";
import PrivacyPolicy from "./PrivacyPolicy";

const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function App() {
  const dispatch = useDispatch();
  const load = async () => {
    const appData = await appLoad();
    console.log("app load", appData);
    dispatch({ type: SET_TASKS, payload: appData.tasks });
    dispatch({ type: LOAD_COURSES, payload: appData.courses });
    dispatch({ type: LOAD_LINKS, payload: appData.links });
    dispatch({ type: SET_CALENDAR_EVENTS, payload: appData.events });
    dispatch({ type: LOAD_TIMESLOTS, payload: appData.scheduled });
    dispatch({ type: LOAD_NEW_SCHEDULED, payload: appData.newScheduled });
  };
  useEffect(() => {
    load();
  }, []);
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const tasks = useSelector((state) => state.tasks.filter((t) => !t.complete));

  const todayTasks = tasks.filter((t) =>
    moment(t.date).isSame(moment(), "day")
  );
  const overdue = tasks.filter(
    (t) => moment(t.date).isBefore(moment()) && !todayTasks.includes(t)
  );
  const pinned = tasks.filter(
    (t) => t.pinned && !overdue.includes(t) && !todayTasks.includes(t)
  );
  const eventually = useSelector((state) =>
    state.scheduler.eventually ? state.scheduler.eventually : []
  );
  const taskData = {
    Overdue: overdue,
    Today: todayTasks,
    Pinned: pinned,
  };
  const numEvents = useSelector(
    (state) =>
      state.calendar.events.filter((e) => e.days[moment().day()]).length
  );
  const recentlyDeleted = useSelector((state) =>
    state.tasks.filter((t) => t.complete)
  );
  const recentlyDeletedScheduled = useSelector(
    (state) => state.scheduler.completed
  );
  const taskClicked = (task) => {
    setClickTasked(task);
    setEditPopup(true);
  };
  const toggleDrawer = () => {
    setOpen((o) => !o);
  };
  const [editPopup, setEditPopup] = useState(false);
  const [clickedTask, setClickTasked] = useState(null);
  const submitNewTask = (task) => {
    if (task) {
      dispatch({ type: ADD_TASK, payload: task });
    }
    setEditPopup(false);
  };
  const undoDelete = (task) => {
    dispatch({ type: UNDO_DELETE_TASK, payload: task.id });
  };
  const fullDelete = (task) => {
    dispatch({ type: DELETE_TASK, payload: task.id });
  };
  const undoDeleteScheduled = (task) => {
    dispatch({ type: UNDO_DELETE_SCHEDULED, payload: task });
  };
  const fullDeleteScheduled = (task) => {
    dispatch({ type: DELETE_SCHEDULED, payload: task });
  };
  return (
    <BrowserRouter>
      <Box
        sx={{
          display: "flex",
          height: "100%",
        }}
      >
        <AppBar
          position="fixed"
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              edge="start"
              sx={{
                marginRight: 5,
              }}
            >
              <MenuIcon />
            </IconButton>
            <Header />
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          open={open}
          sx={{
            flexShrink: 0,
          }}
        >
          <Toolbar />
          <List>
            {["Overdue", "Today", "Pinned"].map((text, index) => (
              <div>
                <ListItem
                  key={text}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    {index == 0 ? (
                      <AccessAlarmIcon />
                    ) : index == 1 ? (
                      <TodayIcon />
                    ) : (
                      <PriorityHighIcon />
                    )}
                    {!open && taskData[text].length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: -10,
                          right: -10,
                          backgroundColor: "#f55",
                          borderRadius: "50%",
                          borderColor: "white",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          width: 15,
                          height: 15,
                          textAlign: "center",
                          fontSize: 12,
                        }}
                      >
                        {taskData[text].length}
                      </div>
                    )}
                  </ListItemIcon>
                  <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
                </ListItem>
                {open && (
                  <div
                    style={{
                      marginLeft: "5%",
                      marginRight: "5%",
                      paddingLeft: "5%",
                      paddingRight: "5%",
                      borderBottomStyle: index < 3 ? "solid" : "none",
                      borderBottomColor: "#777",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {taskData[text].map((t) => (
                      <TaskPreview
                        showDate={index % 2 == 0}
                        task={t}
                        onClick={taskClicked}
                      />
                    ))}
                  </div>
                )}
              </div>
            ))}
            <div>
              <ListItem
                key={"Eventually"}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <HelpOutlineIcon />
                  {!open && eventually.length > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        backgroundColor: "#f55",
                        borderRadius: "50%",
                        borderColor: "white",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        width: 15,
                        height: 15,
                        textAlign: "center",
                        fontSize: 12,
                      }}
                    >
                      {eventually.length}
                    </div>
                  )}
                </ListItemIcon>
                <ListItemText
                  primary="Eventually"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
              {open && (
                <div
                  style={{
                    marginLeft: "5%",
                    marginRight: "5%",
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    borderBottomStyle: "none",
                    borderBottomColor: "#777",
                    display: "flex",
                    flexFlow: "column",
                    flexGrow: 1,
                    minHeight: "30px",
                    width: "75%",
                    backgroundColor: "#eee",
                    borderRadius: "5px",
                    borderStyle: "solid",
                    borderColor: "#ddd",
                  }}
                >
                  <TaskContainer
                    id="eventually"
                    canCreate={true}
                    label="Hi"
                    labelColor="transparent"
                  />
                </div>
              )}
            </div>
          </List>
          <Divider />
          <div>
            <List>
              <ListItem
                key={"Calendar2"}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <TodayIcon />
                  {!open && numEvents > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        backgroundColor: "#f55",
                        borderRadius: "50%",
                        borderColor: "white",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        width: 15,
                        height: 15,
                        textAlign: "center",
                        fontSize: 12,
                      }}
                    >
                      {numEvents}
                    </div>
                  )}
                </ListItemIcon>
                <ListItemText
                  primary="Calendar"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
              {open && <DayCalendar />}
              <ListItem
                key={"Calendar"}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <CheckCircleOutlineIcon />
                  {!open &&
                    recentlyDeleted.length + recentlyDeletedScheduled.length >
                      0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: -10,
                          right: -10,
                          backgroundColor: "#f55",
                          borderRadius: "50%",
                          borderColor: "white",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          width: 15,
                          height: 15,
                          textAlign: "center",
                          fontSize: 12,
                        }}
                      >
                        {recentlyDeleted.length +
                          recentlyDeletedScheduled.length}
                      </div>
                    )}
                </ListItemIcon>
                <ListItemText
                  primary="Recently Completed"
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItem>
              {open &&
                recentlyDeleted.map((t) => (
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "40px", height: "40px" }}>
                      <IconButton size="small" onClick={() => undoDelete(t)}>
                        <UndoOutlined />
                      </IconButton>
                    </div>
                    <div style={{ width: "40px", height: "40px" }}>
                      <IconButton size="small" onClick={() => fullDelete(t)}>
                        <Delete />
                      </IconButton>
                    </div>
                    <TaskPreview task={t} onClick={taskClicked} />
                  </div>
                ))}
              {open &&
                recentlyDeletedScheduled.map((t) => (
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "40px", height: "40px" }}>
                      <IconButton
                        size="small"
                        onClick={() => undoDeleteScheduled(t)}
                      >
                        <UndoOutlined />
                      </IconButton>
                    </div>
                    <div style={{ width: "40px", height: "40px" }}>
                      <IconButton
                        size="small"
                        onClick={() => fullDeleteScheduled(t)}
                      >
                        <Delete />
                      </IconButton>
                    </div>
                    <ScheduledTask task={t} setComplete={null} />
                  </div>
                ))}
            </List>
          </div>
        </Drawer>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            display: "flex",
            flexFlow: "column",
          }}
        >
          <div style={{ paddingTop: "40px", flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="schedule" element={<Calendar />} />
              <Route path="scheduler" element={<Scheduler />} />
              <Route path="calendar" element={<TaskCalendar />} />
              <Route path="preferences" element={<Preferences />} />
              <Route path="privacy" element={<PrivacyPolicy />} />
            </Routes>
          </div>
        </Box>
      </Box>
      <TaskPopup
        open={editPopup}
        onClose={submitNewTask}
        initialTask={clickedTask}
      />
    </BrowserRouter>
  );
}
